// extracted by mini-css-extract-plugin
export default {"main__section":"Main_main__section__KSoeJ","main__title":"Main_main__title__Mkc7q","main__group":"Main_main__group__iKc8Z"};